import React, { useRef } from "react";
import { useMount } from "react-use";

import { useIncode } from "./IncodeContext";

export const TutorialBackId = () => {
  const containerRef = useRef(null);
  const { incode, token, navigateTo, track } = useIncode();

  useMount(() => {
    track("tutorial_back_viewed");
    incode.renderBackTutorial(containerRef.current, {
      token: { token },
      onSuccess: () => navigateTo("back"),
      noWait: true,
    });
  });

  return <div ref={containerRef}></div>;
};
